import nxModule from 'nxModule';
import templateUrl from './customer-type-constraint.template.html'

class CustomerTypeConstraint {
  constructor() {
    this.customerTypes = [
      {
        label: 'Individual',
        value: 'INDIVIDUAL'
      },
      {
        label: 'Corporate',
        value: 'CORPORATE'
      }
    ];
    this.loanCustomerTypes = [
      ...this.customerTypes,
      {
        label: 'Group',
        value: 'GROUP'
      }
    ];
  }

  $onInit() {
    if (this.onCustomerTypeChange) {
      this.onChangeFunc = this.onCustomerTypeChange;
    } else {
      this.onChangeFunc = () => {};
    }
  }

  onChange() {
    // ng-change fires before the two-way binding copies the new selection to the
    // parent, so the parent gets it as an argument instead of reading its own model.
    this.onChangeFunc(this.customerTypeConstraints);
  }
}

nxModule.component('customerTypeConstraint', {
  templateUrl,
  bindings: {
    customerTypeConstraints: '=',
    onCustomerTypeChange: '=',
    productType: '<'
  },
  controller: CustomerTypeConstraint
});